export default {
  buyer: [
    {
      name: 'Profile',
      link: '/user/{username}',
      icon: 'e-icon -icon-person'
    },
    {
      name: 'Envato Account',
      link: '//account.envato.com',
      icon: 'e-icon -icon-envato'
    },
    {
      name: 'Settings',
      link: '/user/{username}/personal_information/edit',
      icon: 'e-icon -icon-cog'
    },
    {
      name: 'Downloads',
      link: '/downloads',
      icon: 'e-icon -icon-download'
    },
    {
      name: 'Favorites',
      link: '/favorites',
      icon: 'e-icon -icon-favorite'
    },
    {
      name: 'Collections',
      link: '/collections/manage',
      icon: 'e-icon -icon-folder-open'
    },
    {
      name: 'Follow Feed',
      link: '/follow_feed',
      icon: 'e-icon -icon-people'
    },
    {
      name: 'Statement',
      link: '/user/{username}/statement',
      icon: 'e-icon -icon-document-filled'
    },
    {
      name: 'Add Credit',
      link: '/payment/deposit/new',
      icon: 'e-icon -icon-dollar'
    }
  ],
  nonAuthor: [
    {
      name: 'Become an Author',
      link: 'https://author.envato.com',
      icon: 'e-icon -icon-moneybag'
    }
  ],
  author: [
    {
      name: 'Author Dashboard',
      link: '/author_dashboard',
      icon: 'e-icon -icon-gauge'
    },
    {
      name: 'Upload',
      link: '/upload',
      icon: 'e-icon -icon-upload'
    },
    {
      name: 'Portfolio',
      link: '/user/{username}/portfolio',
      icon: 'e-icon -icon-briefcase'
    },
    {
      name: 'Earnings',
      link: '/user/{username}/earnings',
      icon: 'e-icon -icon-moneybag'
    },
    {
      name: 'Withdrawals',
      link: '/accounts/withdrawal/new',
      icon: 'e-icon -icon-withdrawal'
    }
  ]
}



// WEBPACK FOOTER //
// ./common/constants/userMenuConfig.js